// These insets ensure that features are never visible past the edges of
// the map. The popup can overflow a bit, but it's marker anchor should
// not. In general, if the marker is hidden, the popup should be too.
export const RIGHT_INSET = window.devicePixelRatio > 1 ? -370 : 0;
export const BOTTOM_INSET = window.devicePixelRatio > 1 ? -670 : 0;
